// Mock data for MasterX

export const heroSlides = [
  {
    id: 1,
    title: "Toy Story 5",
    subtitle: "Animação 2026",
    image: "https://image.tmdb.org/t/p/w1280/sssrBhdvDcczgMQYDc8oCoSuFEJ.jpg",
    description: "Woody, Buzz e toda a turma enfrentam um novo desafio: a era dos eletrônicos.",
    youtube: "hero0001",
  },
  {
    id: 2,
    title: "Moana",
    subtitle: "Aventura 2026",
    image: "https://image.tmdb.org/t/p/w1280/e0ImfFh3aQ9P0PS81DudN9TZTmA.jpg",
    description: "A corajosa navegadora ganha vida em live-action numa nova aventura pelos mares do Pacífico.",
    youtube: "hero0002",
  },
  {
    id: 3,
    title: "Pânico 7",
    subtitle: "Terror 2026",
    image: "https://image.tmdb.org/t/p/w1280/rEevavl5vebCVEd5imx7D1k8nmV.jpg",
    description: "Ghostface está de volta e Sidney Prescott precisa enfrentar o passado mais uma vez.",
    youtube: "hero0003",
  },
  {
    id: 4,
    title: "Homem-Aranha: Um Novo Dia",
    subtitle: "Ação 2026",
    image: "https://image.tmdb.org/t/p/w1280/x0nvYzQpyJc5pdT9lMnkMuYAg0O.jpg",
    description: "Peter Parker retorna em uma nova aventura que promete abalar o multiverso da Marvel.",
    youtube: "abc99101",
  },
  {
    id: 5,
    title: "O Diabo Veste Prada 2",
    subtitle: "Comédia 2026",
    image: "https://image.tmdb.org/t/p/w1280/50yWyY981TyUHhoxxSEKwO70FmQ.jpg",
    description: "Miranda Priestly volta ao comando com um novo desafio: sobreviver na era digital.",
    youtube: "abc22201",
  },
  {
    id: 6,
    title: "Mortal Kombat 2",
    subtitle: "Ação 2026",
    image: "https://image.tmdb.org/t/p/w1280/iILiJSRViTEcF23MHhGCbVm3mfW.jpg",
    description: "O torneio mais brutal do multiverso retorna com Johnny Cage e novos guerreiros lendários.",
    youtube: "abc33333",
  },
  {
    id: 7,
    title: "A Odisseia",
    subtitle: "Épico 2026",
    image: "https://image.tmdb.org/t/p/w1280/muMwJAiMtReEHLKpKMWt2rMkYF7.jpg",
    description: "A lendária jornada de Ulisses ganha vida em uma superprodução épica dirigida por Christopher Nolan.",
    youtube: "abc99103",
  },
];

const tmdb = (p) => `https://image.tmdb.org/t/p/w500${p}`;

export const sections = [
  {
    id: "lancamentos",
    icon: "flame",
    title: "Lançamentos 2026",
    description: "Filmes novos que acabam de sair do Cinema, atualização semanal... tudo oque chegar de novidade a gente tem!",
    items: [
      { id: "l1", type: "Filme", title: "Garotas Só Querem Vingança (2026)", image: tmdb("/xkBiIyrA8nyNENUulj27ptCnRxE.jpg"), youtube: "l00001" },
      { id: "l2", type: "Filme", title: "Ninja Wars: BlackFox vs Shogun's Ninja (2026)", image: tmdb("/1lkVoZZiZ6LIKCEeCojblCf8eYP.jpg"), youtube: "l00002" },
      { id: "l3", type: "Filme", title: "O Amor Mata (2026)", image: tmdb("/x2mZwTtQ2KhrxIfocBFeAnqk1sE.jpg"), youtube: "l00003" },
      { id: "l4", type: "Filme", title: "Refém Por Um Fio (2026)", image: tmdb("/ln9Uf8cfbRImDn6K8xguCbNiQQe.jpg"), youtube: "l00004" },
      { id: "l5", type: "Filme", title: "Ricos Sem Dinheiro (2026)", image: tmdb("/5n4Po7mgGQKxGQav9tO4A390A6O.jpg"), youtube: "l00005" },
      { id: "l6", type: "Filme", title: "Sete Atiradores (2026)", image: tmdb("/u4lRmVcqLch4cqMfSDuBolpl3l9.jpg"), youtube: "l00006" },
      { id: "l7", type: "Filme", title: "Soulm8te (2026)", image: tmdb("/bNErActDctl6cdUGw9pnjSCmyhQ.jpg"), youtube: "l00007" },
      { id: "l8", type: "Filme", title: "Cartas de Redenção (2026)", image: tmdb("/kDFNGzkXZPJPXXy1hdO4Do4X3Wh.jpg"), youtube: "l00008" },
      { id: "l9", type: "Filme", title: "Hora do Recreio (2026)", image: tmdb("/tQEYpspHXXgDJeUmHoDJzEGtf7.jpg"), youtube: "l00009" },
      { id: "l10", type: "Filme", title: "O Bolo do Presidente (2026)", image: tmdb("/pwxoDB6zD11cSeWdE5pEXpDfyoV.jpg"), youtube: "l00010" },
      { id: "l11", type: "Filme", title: "2DIE4: 24 Horas no Limite (2026)", image: tmdb("/m0UoQo6aiCT3SaO3Xar6dLVqLlZ.jpg"), youtube: "l00011" },
      { id: "l12", type: "Filme", title: "Live dos Infernos (2026)", image: tmdb("/1bK88wukSx3FAhYEjH2p8RRkyH9.jpg"), youtube: "l00012" },
      { id: "l13", type: "Filme", title: "Batman: A Queda do Morcego - Parte 1 (2026)", image: tmdb("/kOeLi6uIhAlWchS7ZkgDwWSavYT.jpg"), youtube: "l00013" },
      { id: "l14", type: "Filme", title: "Socorro! Minha Babá Tirou Férias! (2026)", image: tmdb("/nmUHSmxdtziMndnz0ArbHCxMibG.jpg"), youtube: "l00014" },
      { id: "l15", type: "Filme", title: "Unabomber (2026)", image: tmdb("/xVRIUBkQvapWRjYwCbPvb0NfH37.jpg"), youtube: "l00015" },
      { id: "l16", type: "Filme", title: "Como Perder Sua Popularidade (2026)", image: tmdb("/dClmfjS3cMam0NDfThWeeJMioJM.jpg"), youtube: "l00016" },
      { id: "l17", type: "Filme", title: "Conexão Perigosa (2026)", image: tmdb("/4aBIocnMHvb7b6yBT1tYTYvV430.jpg"), youtube: "l00017" },
      { id: "l18", type: "Filme", title: "Criadas (2026)", image: tmdb("/ee0RFg0A4d7t8X5lQvlELLcFFds.jpg"), youtube: "l00018" },
      { id: "l19", type: "Filme", title: "Insaciável (2026)", image: tmdb("/dxkFhIg6a2yilee5A7mZrv2GXWi.jpg"), youtube: "l00019" },
      { id: "l20", type: "Filme", title: "Sem Cortes (2026)", image: tmdb("/jVCpljwYNJhGCBR9DzqiGV0jxAe.jpg"), youtube: "l00020" },
      { id: "l21", type: "Filme", title: "Toy Story 5 (2026)", image: tmdb("/sssrBhdvDcczgMQYDc8oCoSuFEJ.jpg"), youtube: "l00021" },
      { id: "l22", type: "Filme", title: "A Hipótese do Amor (2026)", image: tmdb("/9TQyjZ9PHCiPR8eylF8dulUFreu.jpg"), youtube: "l00022" },
      { id: "l23", type: "Filme", title: "A Morte de Robin Hood (2026)", image: tmdb("/o0QndnepFPWget2kdKpzh26RBYt.jpg"), youtube: "l00023" },
      { id: "l24", type: "Filme", title: "Earth, Wind & Fire (2026)", image: tmdb("/eCxbErDh65qZqXMvPK5ZeX9X9Jl.jpg"), youtube: "l00024" },
    ],
  },
  {
    id: "drama",
    title: "Drama",
    description: "Depois dizem que nós é quem somos dramáticos, pois temos uma enorme variedade de filmes dramáticos, ação real, baseados em histórias reais. É muita jóia rara. Confira!...",
    items: [
      { id: "d1", type: "Filme", title: "Como Uma Onda no Mar (2025)", image: tmdb("/d1EhLFtfWgOXVhByDxuos6HDovw.jpg"), youtube: "d00001" },
      { id: "d2", type: "Filme", title: "Magazine Dreams (2025)", image: tmdb("/vSidx9NHKuQIPEQ4yI9b9zkTeh3.jpg"), youtube: "d00002" },
      { id: "d3", type: "Filme", title: "O Bom Professor (2024)", image: tmdb("/66n2RObfT9YOQlesutatOTjMBAm.jpg"), youtube: "d00003" },
      { id: "d4", type: "Filme", title: "Contrato das Sombras (2024)", image: tmdb("/zHITbNWPLuyrJ8F7kZGZLEBPwar.jpg"), youtube: "d00004" },
      { id: "d5", type: "Filme", title: "Queer (2024)", image: tmdb("/xe4b2TMciLKA1C0JlhWxb4ENLln.jpg"), youtube: "d00005" },
      { id: "d6", type: "Filme", title: "Um Lugar para Recomeçar (2023)", image: tmdb("/uipnnkw5t20rFmRFqiluQfcJL5c.jpg"), youtube: "d00006" },
      { id: "d7", type: "Filme", title: "Plutão (2023)", image: tmdb("/wcPfzgn35A9vL23mNgkFhTncSne.jpg"), youtube: "d00007" },
      { id: "d8", type: "Filme", title: "Dr. Semmelweis (2023)", image: tmdb("/ea105uIesnD56ajaPsRDVTm3Fmm.jpg"), youtube: "d00008" },
      { id: "d9", type: "Filme", title: "Sayen (2023)", image: tmdb("/aCy61aU7BMG7SfhkaAaasS0KzUO.jpg"), youtube: "d00009" },
      { id: "d10", type: "Filme", title: "Tentação Perigosa (2023)", image: tmdb("/2mVLnyRPRGS8vQPX7CPVAcPo1iW.jpg"), youtube: "d00010" },
      { id: "d11", type: "Filme", title: "Código de Ética (2023)", image: tmdb("/zNUR5VWzU1VNM1JAAHIb46588Ke.jpg"), youtube: "d00011" },
      { id: "d12", type: "Filme", title: "Nas Areias de Ibiza (2023)", image: tmdb("/2eNommA60rHFMk7WW6TkJJZECfB.jpg"), youtube: "d00012" },
      { id: "d13", type: "Filme", title: "Operação Tempestade (2023)", image: tmdb("/p6JUa50d3IidLJOz1E0QxXgXp59.jpg"), youtube: "d00013" },
      { id: "d14", type: "Filme", title: "O Peso de Um Sonho (2023)", image: tmdb("/2G79AfMBS3ClLZL26YFvfkZqKzk.jpg"), youtube: "d00014" },
      { id: "d15", type: "Filme", title: "Uma Vida Inteira (2023)", image: tmdb("/owHOn8uCmS1g0Zhv142CrQzAVo.jpg"), youtube: "d00015" },
    ],
  },
  {
    id: "rockinrio",
    icon: "music",
    title: "Rock in Rio (Musical)",
    description: "Shows e muitas Trilhas sonoras de tirar o fôlego em Rock in Rio...",
    items: [
      { id: "r1", type: "Show", title: "Jão no Rock in Rio 2024", image: tmdb("/A14vDgS4jVZaV0Qk85MFBbu9gqj.jpg"), youtube: "r00001" },
      { id: "r2", type: "Show", title: "Karol G no Rock in Rio 2024", image: tmdb("/A14vDgS4jVZaV0Qk85MFBbu9gqj.jpg"), youtube: "r00002" },
      { id: "r3", type: "Show", title: "Kaskade no Rock in Rio 2024", image: tmdb("/A14vDgS4jVZaV0Qk85MFBbu9gqj.jpg"), youtube: "r00003" },
      { id: "r4", type: "Show", title: "Katy Perry no Rock in Rio 2024", image: tmdb("/A14vDgS4jVZaV0Qk85MFBbu9gqj.jpg"), youtube: "r00004" },
      { id: "r5", type: "Show", title: "Livinho no Rock in Rio 2024", image: tmdb("/A14vDgS4jVZaV0Qk85MFBbu9gqj.jpg"), youtube: "r00005" },
      { id: "r6", type: "Show", title: "Luedji Luna no Rock in Rio 2024", image: tmdb("/A14vDgS4jVZaV0Qk85MFBbu9gqj.jpg"), youtube: "r00006" },
      { id: "r7", type: "Show", title: "Luiz Otávio no Rock in Rio 2024", image: tmdb("/A14vDgS4jVZaV0Qk85MFBbu9gqj.jpg"), youtube: "r00007" },
      { id: "r8", type: "Show", title: "Luísa Sonza no Rock in Rio 2024", image: tmdb("/A14vDgS4jVZaV0Qk85MFBbu9gqj.jpg"), youtube: "r00008" },
      { id: "r9", type: "Show", title: "Mariah Carey no Rock in Rio 2024", image: tmdb("/A14vDgS4jVZaV0Qk85MFBbu9gqj.jpg"), youtube: "r00009" },
      { id: "r10", type: "Show", title: "Maz X Antdot no Rock in Rio 2024", image: tmdb("/A14vDgS4jVZaV0Qk85MFBbu9gqj.jpg"), youtube: "r00010" },
      { id: "r11", type: "Show", title: "Mc Dricka no Rock in Rio 2024", image: tmdb("/A14vDgS4jVZaV0Qk85MFBbu9gqj.jpg"), youtube: "r00011" },
      { id: "r12", type: "Show", title: "Mochakk no Rock in Rio 2024", image: tmdb("/A14vDgS4jVZaV0Qk85MFBbu9gqj.jpg"), youtube: "r00012" },
    ],
  },
  {
    id: "cine",
    icon: "popcorn",
    title: "Cine Pipoca",
    description: "Aquele filme leve e divertido para passar o tempo sem compromisso.",
    items: [
      { id: "cp1", type: "Filme", title: "A Mãe da Noiva (2024)", image: tmdb("/6gnzZDWfxizydSnjjRX36pW88nw.jpg"), youtube: "cp00001" },
      { id: "cp2", type: "Filme", title: "Tripped Up (2023)", image: tmdb("/k0TjTcPfifQXjpTbE7cueD4XFas.jpg"), youtube: "cp00002" },
      { id: "cp3", type: "Filme", title: "Até Marte por Amor (2023)", image: tmdb("/jmvjmR50c3vIegMbfoEoNns84lM.jpg"), youtube: "cp00003" },
      { id: "cp4", type: "Filme", title: "O Tesouro da Montanha Nebulosa (2023)", image: tmdb("/1mMG78tbmYUN5VSy61MeUVzLNco.jpg"), youtube: "cp00004" },
      { id: "cp5", type: "Filme", title: "As Ladras (2023)", image: tmdb("/wnLJ7nVObgbAD7cgF87XW1t9JT2.jpg"), youtube: "cp00005" },
      { id: "cp6", type: "Filme", title: "Agradecimento e Desculpas (2023)", image: tmdb("/24WSZJyiQbLuH1esYnVhJOvQXNx.jpg"), youtube: "cp00006" },
      { id: "cp7", type: "Filme", title: "Desencaixados (2023)", image: tmdb("/qQo7PrvRRGSnNYJqFX0cd5LGiy3.jpg"), youtube: "cp00007" },
      { id: "cp8", type: "Filme", title: "Meu Cunhado é Um Vampiro (2023)", image: tmdb("/w1hyHgP4fyrW9tEqlX472bMgLO9.jpg"), youtube: "cp00008" },
      { id: "cp9", type: "Filme", title: "Festa do Pijama Muito Louca (2023)", image: tmdb("/1i7dglSbXeDUJrGd4rKGhLKzqGJ.jpg"), youtube: "cp00009" },
      { id: "cp10", type: "Filme", title: "Ruim pra Cachorro (2023)", image: tmdb("/hfSkDDJiCf6cJpd4R9O9lM1T6hz.jpg"), youtube: "cp00010" },
      { id: "cp11", type: "Filme", title: "Férias de Verão (2023)", image: tmdb("/mcMj1XhDPyxa0xuZ9aNrbPVs1CJ.jpg"), youtube: "cp00011" },
      { id: "cp12", type: "Filme", title: "Do Not Disturb (2023)", image: tmdb("/gyuMSazHAcTSZRhe17NFMXPXOgi.jpg"), youtube: "cp00012" },
    ],
  },
  {
    id: "aventura",
    title: "Aventura e Ação",
    description: "As melhores produções de aventura e ação épica selecionadas para você.",
    items: [
      { id: "av1", type: "Filme", title: "O Retorno (2025)", image: tmdb("/lX3MexkfEQLrWGJdhuGqJLlhnhf.jpg"), youtube: "av00001" },
      { id: "av2", type: "Filme", title: "Cells at Work! (2024)", image: tmdb("/dtZopDmeDReFTfgi9nPqNF84SHv.jpg"), youtube: "av00002" },
      { id: "av3", type: "Filme", title: "Procura-se Gonker (2023)", image: tmdb("/ziAL5224J9QHA0S0exarpkz4eUN.jpg"), youtube: "av00003" },
      { id: "av4", type: "Filme", title: "Jornada Para Belém (2023)", image: tmdb("/tv0Ta1lAIZYuLKAcQhnRTe8bUTV.jpg"), youtube: "av00004" },
      { id: "av5", type: "Filme", title: "Gran Turismo: De Jogador a Corredor (2023)", image: tmdb("/qU60nhBRbKU23gIGrZi2CvUj6MQ.jpg"), youtube: "av00005" },
      { id: "av6", type: "Filme", title: "Pequenos Espiões: Apocalipse (2023)", image: tmdb("/cwCKYjIPXapuBtO51S81GNhoGxV.jpg"), youtube: "av00006" },
      { id: "av7", type: "Filme", title: "O Portal Secreto (2023)", image: tmdb("/3mu3olAbPYTm4GkEdsr6Bk1MU5.jpg"), youtube: "av00007" },
      { id: "av8", type: "Filme", title: "D.P.A. e a Biblioteca Banida (2023)", image: tmdb("/2jQ7Wtm6MNNn5J8rleBJrwSkedu.jpg"), youtube: "av00008" },
      { id: "av9", type: "Filme", title: "Viking de Mentira (2022)", image: tmdb("/c4dnAFSBX401v5nT57m7iHWoVwn.jpg"), youtube: "av00009" },
      { id: "av10", type: "Filme", title: "O Segredo de Mercator (2022)", image: tmdb("/S7F1B9HyltgbxAVPtErmRx8zmq.jpg"), youtube: "av00010" },
      { id: "av11", type: "Filme", title: "A Única Sobrevivente (2022)", image: tmdb("/nreStPF08Bd5RYH4gjbXVh59XAu.jpg"), youtube: "av00011" },
      { id: "av12", type: "Filme", title: "Enola Holmes 2 (2022)", image: tmdb("/tegBpjM5ODoYoM1NjaiHVLEA0QM.jpg"), youtube: "av00012" },
    ],
  },
  {
    id: "destaques",
    title: "Destaques do Dia",
    description: "Séries que estão bombando hoje e que você não pode perder.",
    items: [
      { id: "dd1", type: "Série", title: "56 Dias 2026", image: tmdb("/bJgbL2qHhKEnDUsVVPYJ6GJfvtW.jpg"), youtube: "abc77001" },
      { id: "dd2", type: "Série", title: "Star Trek: Academia da Frota Estelar (2026)", image: tmdb("/g0cMwV9JQ2uFR7TSgiofViDtfTx.jpg"), youtube: "abc77002" },
      { id: "dd3", type: "Série", title: "Os Abandonados (2025)", image: tmdb("/uObo75pctOV4BjDRRMOBPD05SwL.jpg"), youtube: "abc77003" },
      { id: "dd4", type: "Série", title: "Pequenos Desastres 2025", image: tmdb("/sscYITzIOAfHqxgSqeBUrH8ZmCH.jpg"), youtube: "abc77004" },
      { id: "dd5", type: "Série", title: "O Novato (The Rookie) (2018)", image: tmdb("/yCPGrd6fzbftuaH97OUS6tUdE4B.jpg"), youtube: "abc77005" },
      { id: "dd6", type: "Série", title: "Diários de um Vampiro 2009", image: tmdb("/lcGQaSrWkkxGuh0JJqyN2TkuNqb.jpg"), youtube: "abc77006" },
      { id: "dd7", type: "Série", title: "O Dia em Que a Minha Vida Mudou 2024", image: tmdb("/6Vw926F9swj2XXFJOPig17ArU7C.jpg"), youtube: "abc77007" },
      { id: "dd8", type: "Série", title: "Os Caras Malvados No Pedaço (2025)", image: tmdb("/2MwexoT6ErCY8CBe80dBEV866oF.jpg"), youtube: "abc77008" },
      { id: "dd9", type: "Série", title: "Fire Country 2022 Legendado", image: tmdb("/6XnA02VRG4dhBpTZWGZuXQdYGDW.jpg"), youtube: "abc77009" },
      { id: "dd10", type: "Série", title: "Sky Rojo (2021)", image: tmdb("/uTFX9V2dct1nKjG6zhNiThPm8Tp.jpg"), youtube: "abc77010" },
      { id: "dd11", type: "Série", title: "Insomnia 2024", image: tmdb("/z4sjqU4EpvpyyOyUHJQP1FQM6ro.jpg"), youtube: "abc77011" },
      { id: "dd12", type: "Série", title: "Robin Hood 2025", image: tmdb("/aTBRFl6l1qPW34nuZ1FC3zRgfPE.jpg"), youtube: "abc77012" },
    ],
  },
  {
    id: "historias",
    title: "Grandes Histórias",
    description: "Narrativas marcantes e envolventes para maratonar agora mesmo.",
    items: [
      { id: "gh1", type: "Série", title: "Yoroi-Shinden Samurai Troopers 2026", image: tmdb("/gQDsN26g7RUibJJcgWzPvc0iTnb.jpg"), youtube: "abc66001" },
      { id: "gh2", type: "Série", title: "MF GHOST (2023)", image: tmdb("/vMnd8iqPwOOoIZ9a2RcqAHppDoq.jpg"), youtube: "abc66002" },
      { id: "gh3", type: "Série", title: "Crime de uma Dinastia: O Caso Murdaugh 2025", image: tmdb("/affclX4VpJo18y7Oq3OZj5DIqIJ.jpg"), youtube: "abc66003" },
      { id: "gh4", type: "Série", title: "Uma Loja Para Assassinos 2024", image: tmdb("/hx84Fg4I35nkxtH69e9aOmUVtdR.jpg"), youtube: "abc66004" },
      { id: "gh5", type: "Série", title: "Dexter: Ressurreição (2025)", image: tmdb("/wG6GBTreXHoBhxsFY4vVSQtYey5.jpg"), youtube: "abc66005" },
      { id: "gh6", type: "Série", title: "Lazarus 2025", image: tmdb("/j5Tvg6cF4jM2nB9YrjQ3Jiq3PBn.jpg"), youtube: "abc66006" },
      { id: "gh7", type: "Série", title: "Cortina de Fumaça (2025)", image: tmdb("/dkxMAOiRz1zjlgFAMc3P72xSB3u.jpg"), youtube: "abc66007" },
      { id: "gh8", type: "Série", title: "Memórias de uma Prisão 2023", image: tmdb("/eE2ZK7rcHi3enHn2ut46KT66xFg.jpg"), youtube: "abc66008" },
      { id: "gh9", type: "Série", title: "Homeland - Segurança Nacional", image: tmdb("/1hFGIgADHv24zyuDpByQNqspED5.jpg"), youtube: "abc66009" },
      { id: "gh10", type: "Série", title: "Diabo do Desemprego 2025", image: tmdb("/tXAy2L4SwSe2BiZqRmnf9cDyv5N.jpg"), youtube: "abc66010" },
    ],
  },
  {
    id: "survivor",
    title: "Universo Survivor",
    description: "O melhor do suspense e sobrevivência no catálogo MasterX.",
    items: [
      { id: "sv1", type: "Série", title: "The Walking Dead: Daryl Dixon 2023", image: tmdb("/rtEFcXvfgrCYOaCEvuqxysm1r8H.jpg"), youtube: "abc55001" },
      { id: "sv2", type: "Série", title: "Casos Arquivados: Mortes no Velho Oeste 2025", image: tmdb("/q0hxuV5aa3itwMH2ezTZOdgs5C4.jpg"), youtube: "abc55002" },
      { id: "sv3", type: "Série", title: "Boardwalk Empire: O Império do Contrabando", image: tmdb("/kL6SqlVPpfAof2nQbh1VxkUuXBQ.jpg"), youtube: "abc55003" },
      { id: "sv4", type: "Série", title: "Fear the Walking Dead", image: tmdb("/vUxU39JvOHCsMhPlQTZfPWiw6sE.jpg"), youtube: "abc55004" },
      { id: "sv5", type: "Série", title: "Marvel - Jessica Jones", image: tmdb("/aSkB2d9B8vCKbjmg5Abn9uSFmio.jpg"), youtube: "abc55005" },
      { id: "sv6", type: "Série", title: "The Walking Dead: Um Novo Universo", image: tmdb("/iJc0W299BpNyfHVPSVV4goFZ3pq.jpg"), youtube: "abc55006" },
      { id: "sv7", type: "Série", title: "Detetive Alex Cross (2024)", image: tmdb("/4t2BRfqHaSKUypPV09LkMjEECpQ.jpg"), youtube: "abc55007" },
      { id: "sv8", type: "Série", title: "Roma (2005)", image: tmdb("/6TthtTTZ0H7SUkQxJIv0l9yhOOU.jpg"), youtube: "abc55008" },
      { id: "sv9", type: "Série", title: "The Walking Dead 2010", image: tmdb("/bioOPexzaYnAwa1joJn5QlAvr0H.jpg"), youtube: "abc55009" },
      { id: "sv10", type: "Série", title: "Uma Questão de Química", image: tmdb("/9lN9uhgH2YTIubfQTd2f0rtqnmp.jpg"), youtube: "abc55010" },
      { id: "sv11", type: "Série", title: "Percy Jackson e os Olimpianos 2023", image: tmdb("/63zVMAA4oxz9N8EnkNdR8gpyjKf.jpg"), youtube: "abc55011" },
      { id: "sv12", type: "Série", title: "Walker", image: tmdb("/gYXgu5zGAKx5IBk8CLx44Cjaw99.jpg"), youtube: "abc55012" },
    ],
  },
];

export const liveChannels = [
  { id: "c1", name: "Jogos de hoje HD", category: "Jogos de hoje", hot: true, image: "https://beststorage4you.com/logoscanais/LIVEYOUTUBE.png" },
  { id: "c2", name: "Globo SP HD", category: "Globo Sudeste", hot: true, image: "https://beststorage4you.com/logoscanais/GLOBO.png" },
  { id: "c3", name: "Band SP HD", category: "Band", hot: true, image: "https://beststorage4you.com/logoscanais/BAND.png" },
  { id: "c4", name: "Animal Planet HD", category: "4K", hot: true, image: "https://beststorage4you.com/logoscanais/ANIMALPLANET.png" },
  { id: "c5", name: "Band News HD", category: "4K", hot: true, image: "https://beststorage4you.com/logoscanais/BANDNEWS.png" },
  { id: "c6", name: "CNN Brasil HD", category: "4K", hot: true, image: "https://beststorage4you.com/logoscanais/CNNBRASIL.png" },
  { id: "c7", name: "Discovery Channel HD", category: "4K", image: "https://beststorage4you.com/logoscanais/DISCOVERYCHANNEL.png" },
  { id: "c8", name: "Discovery Home & Health HD", category: "4K", image: "https://beststorage4you.com/logoscanais/DISCOVERYHOME&HEALTH.png" },
  { id: "c9", name: "Discovery Science HD", category: "4K", image: "https://beststorage4you.com/logoscanais/DISCOVERYSCIENCE.png" },
  { id: "c10", name: "Discovery World HD", category: "4K", image: "https://beststorage4you.com/logoscanais/DISCOVERYWORLD.png" },
  { id: "c11", name: "Discovery ID HD", category: "4K", image: "https://beststorage4you.com/logoscanais/ID.png" },
  { id: "c12", name: "Megapix HD", category: "4K", image: "https://beststorage4you.com/logoscanais/MEGAPIX.png" },
  { id: "c13", name: "TNT HD", category: "4K", image: "https://beststorage4you.com/logoscanais/TNT.png" },
  { id: "c14", name: "TV Aparecida HD", category: "4K", image: "https://beststorage4you.com/logoscanais/TVAPARECIDA.png" },
  { id: "c15", name: "SBT SP HD", category: "4K", image: "https://beststorage4you.com/logoscanais/SBT.png" },
  { id: "c16", name: "SporTV 1 HD", category: "4K", image: "https://beststorage4you.com/logoscanais/SPORTV.png" },
  { id: "c17", name: "A&E HD", category: "Filmes & Series", image: "https://beststorage4you.com/logoscanais/A&E.png" },
  { id: "c18", name: "AMC HD", category: "Filmes & Series", image: "https://beststorage4you.com/logoscanais/AMC.png" },
  { id: "c19", name: "AXN HD", category: "Filmes & Series", image: "https://beststorage4you.com/logoscanais/AXN.png" },
  { id: "c20", name: "Adult Swim HD", category: "Variedades", image: "https://beststorage4you.com/logoscanais/Swin.png" },
];

export const activeRooms = [
  { id: 1, master: "@romulo17f2", user: "Jonas", code: "K-45" },
  { id: 2, master: "@romulo17f2", user: "Dionilson", code: "B-68" },
  { id: 3, master: "@romulo17f2", user: "Andrade", code: "Q-26" },
  { id: 4, master: "@brunessa85a2", user: "Nando", code: "V-60" },
  { id: 5, master: "@romulo17f2", user: "Robson", code: "L-52" },
  { id: 6, master: "@brunessa85a2", user: "Igor", code: "C-78" },
  { id: 7, master: "@brunessa85a2", user: "Julia", code: "C-05" },
  { id: 8, master: "@brunessa85a2", user: "Julia", code: "A-69" },
  { id: 9, master: "@romulo17f2", user: "Julia", code: "S-48" },
  { id: 10, master: "@romulo17f2", user: "Marcelo", code: "O-81" },
  { id: 11, master: "@brunessa85a2", user: "Marcelo", code: "U-63" },
  { id: 12, master: "@brunessa85a2", user: "Daniel", code: "L-60" },
  { id: 13, master: "@brunessa85a2", user: "Marcelo", code: "Y-13" },
  { id: 14, master: "@romulo17f2", user: "Mayllon", code: "R-03" },
  { id: 15, master: "@romulo17f2", user: "Bruno", code: "S-27" },
  { id: 16, master: "@brunessa85a2", user: "Marlon", code: "T-28" },
  { id: 17, master: "@brunessa85a2", user: "Haroldo", code: "S-04" },
  { id: 18, master: "@brunessa85a2", user: "Andre luiz", code: "T-87" },
  { id: 19, master: "@brunessa85a2", user: "Edilma", code: "J-46" },
  { id: 20, master: "@romulo17f2", user: "Jose", code: "X-57" },
];

export const actors = [
  "Adriana Esteves", "Adrien Brody", "Anna Kendrick", "Ashley Greene", "Bill Bixby", "Bren Foster",
  "Bruce Dern", "Bruce Willis", "Caleb McLaughlin", "Candace Cameron Bure", "Carmen Machi", "Cauã Reymond",
  "Charlize Theron", "Chris Pratt", "Christopher Lambert", "Colin Farrell", "Courteney Cox", "Cynthia Erivo",
  "Débora Falabella", "Elizabeth Debicki", "Emílio Dantas", "Esther Supreeleela", "Gabrielle Union",
  "Gerard Butler", "Gui Nery", "Isabel May", "Jake Gyllenhaal", "Javier Cámara", "Javier Gutiérrez",
  "Jean Reno", "Lauren Cohan", "Marcello Novaes", "Marcelo Adnet", "Mario Casas", "Mark Dacascos",
  "Michelle Rodriguez", "Morena Baccarin", "Murilo Benício", "Nanda Costa", "Natalie Martinez",
  "Neve Campbell", "Norman Reedus", "Patricia Arquette", "Ralph Fiennes", "Renato Aragão",
  "Ron Perlman", "Samuel L. Jackson", "Sandra Bullock", "Sean Connery", "Taron Egerton",
  "Tyrese Gibson", "Viola Davis", "Wagner Moura", "Zazie Beetz",
];

export const categories = [
  { name: "Filmes | Adultos Gay +18", count: 77 },
  { name: "Filmes | Adultos Hentai +18", count: 40 },
  { name: "Filmes | Adultos Lesb +18", count: 32 },
  { name: "Filmes | Adultos Trans +18", count: 25 },
  { name: "Filmes | Apple TV+", count: 400 },
  { name: "Filmes | Copa Do Mundo 2022", count: 64 },
  { name: "Filmes | Crime", count: 79 },
  { name: "Filmes | GloboPlay", count: 205 },
  { name: "Filmes | Guerra", count: 57 },
  { name: "Filmes | Lançamentos 2026", count: 96 },
  { name: "Filmes | Legendados", count: 3369 },
  { name: "Filmes | Nacional", count: 258 },
  { name: "Filmes | Paramount +", count: 102 },
  { name: "Filmes | Star +", count: 10 },
  { name: "Séries | Adultas +18", count: 1 },
  { name: "Séries | Dorama", count: 377 },
  { name: "Séries | Legendado", count: 158 },
  { name: "Séries | Novelas Mexicanas", count: 20 },
  { name: "Séries | Star +", count: 121 },
  { name: "Séries | Treine em Casa - Aulas", count: 11 },
  { name: "Filmes | DC Comics", count: 32 },
  { name: "Filmes | 4K", count: 786 },
  { name: "Filmes | Adultos +18", count: 1072 },
  { name: "Filmes | Animação", count: 228 },
  { name: "Filmes | Anime", count: 92 },
  { name: "Filmes | Aventura", count: 225 },
  { name: "Filmes | Ação", count: 968 },
  { name: "Filmes | Brasil Paralelo", count: 18 },
  { name: "Filmes | Cinema", count: 8 },
  { name: "Filmes | Comedia", count: 1551 },
  { name: "Filmes | Documentarios", count: 457 },
  { name: "Filmes | Drama", count: 1385 },
  { name: "Filmes | Fantasia", count: 375 },
  { name: "Filmes | Faroeste", count: 164 },
  { name: "Filmes | Ficção", count: 274 },
  { name: "Filmes | Infantil", count: 849 },
  { name: "Filmes | Lançamentos 2025", count: 644 },
  { name: "Filmes | Marvel", count: 43 },
  { name: "Filmes | Prime Video", count: 1426 },
  { name: "Filmes | Religioso", count: 99 },
  { name: "Filmes | Romance", count: 329 },
  { name: "Filmes | Sons Para Dormir", count: 10 },
  { name: "Filmes | Suspense", count: 441 },
  { name: "Filmes | Terror", count: 1175 },
  { name: "Filmes/Disney+", count: 183 },
  { name: "Filmes/Diversos", count: 141 },
  { name: "Filmes/HBOmax", count: 174 },
  { name: "Filmes/Looke/Prime-Video", count: 261 },
  { name: "Filmes/Mercado Play", count: 20 },
  { name: "Filmes/Netflix", count: 553 },
  { name: "Shows", count: 88 },
  { name: "Shows Rock in Rio 2022", count: 34 },
  { name: "Shows Rock in Rio 2024", count: 99 },
  { name: "Shows | Gospel", count: 11 },
  { name: "Stand Up Comedy", count: 25 },
  { name: "Séries | Animação", count: 58 },
  { name: "Séries | Animes", count: 480 },
  { name: "Séries | Apple TV", count: 130 },
  { name: "Séries | Brasil Paralelo", count: 22 },
  { name: "Séries | Crunchyroll", count: 47 },
  { name: "Séries | Cursos / Aulas", count: 24 },
  { name: "Séries | Desenhos", count: 267 },
  { name: "Séries | Discovery+", count: 27 },
  { name: "Séries | Disney +", count: 288 },
  { name: "Séries | Diversas", count: 525 },
  { name: "Séries | Documentarios", count: 264 },
  { name: "Séries | Globoplay", count: 272 },
  { name: "Séries | HBO MAX", count: 420 },
  { name: "Séries | Lollapalooza Brasil 2025", count: 1 },
  { name: "Séries | National Geographic", count: 8 },
  { name: "Séries | Netflix", count: 1240 },
  { name: "Séries | Novelas", count: 430 },
  { name: "Séries | Novelas e Séries Turcas", count: 122 },
  { name: "Séries | Paramount", count: 160 },
  { name: "Séries | Prime Video", count: 385 },
  { name: "Séries | Reality show / Programa de TV", count: 221 },
  { name: "Séries | ReelShort - Mobile", count: 10 },
  { name: "Séries | Shows", count: 5 },
];
